/**
 * 파일명 : com0102p.jsx
 * 설명 : 부서정보등록
 * 수정내역
 ************************************************
 * Version    수정일자      수정자    수정내용      
 ************************************************
 *     
 */

/************************************************
 * Import 영역  
 ************************************************/
/************************************************
 * Import 영역
 ************************************************/
/* React */
import React from 'react';

/* AntD */
import { Input, Layout, Row, Col, Space, Button, Descriptions, Select } from 'antd';

/* 업무 */
import * as CommonProxy from 'libs/CommonProxy';
import * as common from 'libs/common';

/* Reducer */
import { useAppSelector, useAppDispatch } from '../../../redux/hooks';
import { Com0102pAction } from '../../../redux/slice/com/com0102p_slice';
import { IDeptCdState, IDeptStCdState } from '../../../redux/models/com/com0102p_model';

/************************************************
 * 전역변수 선언영억
 ************************************************/
const Com0102p = (props:any) => {
    /************************************************
     * 화면 초기화 영역  
     ************************************************/
    /**
     * 기능 : State / Reducer 선언
     * param : 
     */
     const { deptCd, upperDeptCd, deptNm, deptStCd } = props; 
     const dispatch = useAppDispatch();
     const newDeptItems  = useAppSelector((state) => state.Com0102p.newDeptItems);  // 부서등록
     const deptCdList    = useAppSelector((state) => state.Com0102p.deptCdList);    // 부서코드
     const deptStCdList  = useAppSelector((state) => state.Com0102p.deptStCdList);  // 부서상태구분코드



    /**
     * 기능 : componentDidMount
     * 설명 : 화면 최초 로드시에 필요한 기능을 구현한다.
     * param : 
     * return : None
     */
    React.useEffect(() => {
        // 부모로부터 받은 'record' 값을 상태에 초기화
        if (props) {
            dispatch(Com0102pAction.setDeptItems({
                ...newDeptItems,
                deptCd: deptCd || '',
                upperDeptCd: upperDeptCd || '',
                deptNm: deptNm || '',
                deptStCd: deptStCd || '',
            }));
        }
        setDeptStCdList();
        setDeptCdsList();
    }, []);

    /* Render 변수 선언영역 */
    /* AntD */
    const { Content } = Layout;

    /**
     * 기능 : setDeptStCdList
     * 설명 : 부서상태
     * param : 
     * return : None
     **/
    const setDeptStCdList = () => {
        const option = {
            useYn: 'Y',
            callback: (datas:IDeptStCdState[]) => {
                let arrOptions:IDeptStCdState[] = [];

                datas.forEach((item:IDeptStCdState) => {
                    arrOptions.push({
                        label: item.cdNm,
                        value: item.cd,
                    });
                });

                dispatch(Com0102pAction.setDeptStCdList(arrOptions));
            }

        };
        common.getComCodeList('006', option);
    }
    
    React.useEffect(() => 
        {dispatch({ type: 'SET_STATE', data_node: 'deptStCdList', value: deptStCdList, });
    }, [deptStCdList]);


    /**
     * 기능 : setDeptCdsList
     * 설명 : 부서코드
     * param : 
     * return : None
     **/
    const setDeptCdsList = () => {

        const requestData = {
            deptStCd : 'A' ,
        };

        /* 트렌젝션 호출 및 결과 셋팅 */
        CommonProxy.callAsyncSvc(requestData, {
            txCd: 'TRCOMR0005',
            success: (responseData:any) => {            
                // 이름순으로 정렬
                responseData.deptItems.sort((a:IDeptCdState, b:IDeptCdState) => (a.deptNm > b.deptNm) ? 1 : -1)
                dispatch(Com0102pAction.setDeptCdList(responseData.deptItems));
            },
        });
    };

    const deptOptions = React.useCallback(() => {
        let arrOptions: IDeptCdState[] = [];

        deptCdList.forEach((item:IDeptCdState) => {
            arrOptions.push({
                label: item.deptNm,
                value: item.deptCd
            });
        });

        return arrOptions;
    }, [deptCdList]);

    /************************************************
     * 이벤트 함수 영역
     ************************************************/
	/**
     * 기능 : 저장버튼 클릭 이벤트
     * 설명 : 등록/수정
     * param : 
     * return : None
     */

    const btnSave_onClick = () => {
        /* 정합성 체크 */
        if (!fn_CheckValidation('save')) {
            return;
        }

        /* 변수선언 및 셋팅 영역 */
        // 입력파라미터
        const requestData = { ...newDeptItems };

        /* 트렌젝션 호출 및 결과 셋팅 */
        CommonProxy.callAsyncSvc(requestData, {
            txCd: 'TRCOMS0001',
            success: (responseData:any) => {
                dispatch(Com0102pAction.setDeptItems(responseData.deptItems));

                const param = {
                    title : '위드정보 확인',
                    contents: '정상적으로 처리되었습니다.',
                };

                common.openAlert(param);
            },
        });
    };

	/**
     * 기능 : 초기화
     * 설명 : 입력컴포넌트
     * param : 
     * return : None
     */
    const btnReset_onClick = React.useCallback(() => {
        dispatch(Com0102pAction.initState());
    }, []);

    /**
     * 기능 : onClick 이벤트 선언
     * param : 
     */
    const onClick = async (e:React.MouseEvent<HTMLButtonElement>) => {
        const buttonName = e.currentTarget.name;
        switch (buttonName) {
            case 'btnReset': {
                btnReset_onClick();
                break;
            }
            case 'btnSave': {
                btnSave_onClick();
                break;
            }
            case 'btnClose': {
                props.cancel();
                break;
            }
            default:
        }
    };

    /************************************************
     * 개발자함수 영역
     ************************************************/
	/**
     * 기능 : 정합성체크
     * 설명 : 정합성체크
     * param : 
     * return : None
     */
    const fn_CheckValidation = (tran_div:string) => {
        let result = true;

        if (tran_div === 'save') {
            
            if(common.isEmptyString(newDeptItems.deptStCd)) {
                const param = {
                    title : '위드정보 확인',
                    contents: '부서상태는 필수입력 항목입니다.',
                };
                common.openInfo(param);
                return false;
            }
            
            if(common.isEmptyString(newDeptItems.deptNm)) {
                const param = {
                    title : '위드정보 확인',
                    contents: '부서명은 필수입력 항목입니다.',
                };
                common.openInfo(param);
                return false;
            }
            
            if(common.isEmptyString(newDeptItems.upperDeptCd)) {
                const param = {
                    title : '위드정보 확인',
                    contents: '상위부서는 필수입력 항목입니다.',
                };
                common.openInfo(param);
                return false;
            }
            
            return result;
        }
        return result;
    }

    return (
        /* 화면 디자인 영역*/
        <Layout>
            <Content>
                <Descriptions bordered column={2} size='small' >
                    <Descriptions.Item label='* 부서코드'>
                        <Input id='inputDeptCd' name='deptCd' value={newDeptItems.deptCd} style={{ width: '100%', maxWidth: '800px' }} disabled={true} onChange={e => { dispatch(Com0102pAction.setDeptItems({ ...newDeptItems, deptCd : e.currentTarget.value })) }} />
                    </Descriptions.Item>
                    <Descriptions.Item label='* 부서상태'>
                        <Select 
                            style={{
                                width: '100%',
                            }}
                            optionFilterProp='label'
                            options={deptStCdList}
                            value={newDeptItems.deptStCd}
                            disabled={!common.isAdmin()}
                            onChange={val => 
                                dispatch(Com0102pAction.setDeptItems({...newDeptItems, deptStCd: val}))}
                        ></Select>
                    </Descriptions.Item>
                    <Descriptions.Item label='* 부서명'>
                        <Input id='inputDeptNm' name='deptNm' autoComplete='off'  value={newDeptItems.deptNm} style={{ width: '100%', maxWidth: '800px' }} disabled={!common.isAdmin()} onChange={e => { dispatch(Com0102pAction.setDeptItems({ ...newDeptItems, deptNm : e.currentTarget.value })) }}/>
                    </Descriptions.Item>
                    <Descriptions.Item label={newDeptItems.deptCd === 'TGSDEPT001' ? '상위부서' : '* 상위부서'}>
                        <Select 
                            style={{
                                width: '100%',
                                minWidth: 150
                            }}
                            showSearch
                            optionFilterProp='label'
                            defaultValue=''
                            options={deptOptions()}
                            value={  newDeptItems.upperDeptCd}
                            disabled={!common.isAdmin()}
                            onChange={val => dispatch(Com0102pAction.setDeptItems({...newDeptItems, upperDeptCd: val}))}
                        ></Select>
                    </Descriptions.Item>
                </Descriptions>
                    <Row justify='center' style={{ marginTop: 20 }}>
                        <Space size='small'>
                            {common.isAdmin() ?
                            <Button
                                name='btnReset'
                                className='background-color-default-button'
                                onClick={onClick}
                                >
                                초기화
                            </Button> : null}
                            {common.isAdmin() ?
                            <Button
                                name='btnSave'
                                className='background-color-primary-button'
                                onClick={onClick}
                            >
                                저장
                            </Button> : null}
                            <Button
                                name='btnClose'
                                className='background-color-default-button'
                                onClick={onClick}
                            >
                                닫기
                            </Button>
                        </Space>
                    </Row>
            </Content>
        </Layout>
    );
}

export default Com0102p;